module.exports = __webpack_public_path__ + "img/2.8bc99558.png";